<template>
    <div class="page-container">
        <router-view></router-view>
    </div>
</template>

<script>
import { Icon } from 'vhtml-ui';
import Back from 'src/components/back';

const req = require.context('@/assets/icons', false, /[^.]+\.svg$/);
Icon.addSprites(req);

export default {
    components: {
        Back
    },
    data() {
        return {};
    },
    computed: {},

    created() {},

    methods: {}
};
</script>
<style lang="less" scope>
@import './style.less';
.content-title {
    padding: 10px 0 20px;
}
</style>
